import { IAction } from 'src/typings';
import { ActionTypes } from './actions';

export interface IGlobalGridReducer {
  gridCount: number;
  oneGridWidth: number;
  gridContainerWidth: number | null;
  gapWidth: number;
  offset: number;
}

export const initialState: IGlobalGridReducer = {
  gridCount: 6,
  oneGridWidth: 180,
  gridContainerWidth: null,
  gapWidth: 16,
  offset: 32,
};

export const globalGridReducer = (
  state = initialState,
  { type, payload }: IAction,
): IGlobalGridReducer => {
  switch (type) {
    case ActionTypes.SET_GRID_CONTAINER_WIDTH: {
      return {
        ...state,
        gridContainerWidth: payload,
      };
    }
    case ActionTypes.SET_GLOBAL_GRID: {
      return {
        ...state,
        gridCount: payload.gridCount,
        oneGridWidth: payload.oneGridWidth,
        gridContainerWidth: payload.gridContainerWidth,
        gapWidth: payload.gapWidth,
        offset: payload.offset,
      };
    }
    default: return state;
  }
};
